export default {
  label: 'Tipo de Publicação',
  placeholder: 'Todos',
  items: {
    all: 'Todos',
    organic: 'Orgânico',
    boosted: 'Impulsionado',
  },
};
